import { apiSlice } from '../../api/apiSlice';

export const companionAppUsageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanionAppUsageDistrictFilters: builder.mutation({
      query: (options) => ({
        url: `CompanionAppUsage/Districts/${options.skip}/${options.take}`,
        method: 'GET',
        params: {
          searchString: options.searchString || ''
        }
      })
    }),
    getCompanionAppUsageSchoolFilters: builder.mutation({
      query: (options) => ({
        url: `CompanionAppUsage/Schools/${options.skip}/${options.take}`,
        method: 'GET',
        params: {
          districtId: options.districtId ?? -1,
          searchString: options.searchString || ''
        }
      })
    }),
    getCompanionAppUsageTeacherFilters: builder.mutation({
      query: (options) => ({
        url: `CompanionAppUsage/Teachers/${options.skip}/${options.take}`,
        method: 'GET',
        params: {
          districtId: options.districtId ?? -1,
          schoolId: options.schoolId ?? -1,
          searchString: options.searchString || ''
        }
      })
    }),
    getCompanionAppUsageStudentFilters: builder.mutation({
      query: (options) => ({
        url: `CompanionAppUsage/Students/${options.skip}/${options.take}`,
        method: 'GET',
        params: {
          districtId: options.districtId ?? -1,
          schoolId: options.schoolId ?? -1,
          teacherId: options.teacherId ?? -1,
          searchString: options.searchString || ''
        }
      })
    }),
    getCompanionAppUsageReport: builder.mutation({
      query: (options) => ({
        url: 'CompanionAppUsage/Report',
        method: 'GET',
        params: { ...options }
      })
    })
  })
});

export const {
  useGetCompanionAppUsageDistrictFiltersMutation,
  useGetCompanionAppUsageSchoolFiltersMutation,
  useGetCompanionAppUsageTeacherFiltersMutation,
  useGetCompanionAppUsageStudentFiltersMutation,
  useGetCompanionAppUsageReportMutation
} = companionAppUsageApi;
